class UpdateDetails {
  constructor() {
    this.basicUpdate = true;
    this.locationUpdate = true;
    this.user_Id = 0;
    this.created_For = 0;
    this.first_Name = null;
    this.last_Name = null;
    this.age = null;
   

    this.height = null;
    this.weight = null;
    this.marital_Status = null;
    this.body_Type = null;
    this.disability = null;
    this.mother_Tongue = null;
    this.eating_Habit = null;
    this.smoking_Habit = null;
    this.drinking_Habit = null;
    this.living_Preference = null;

    this.religion = 0;
    this.caste = 0;
    this.subCaste = "";
    this.gothram = "";
     this.date_Of_Birth = null;
    this.time_of_Birth=null;
    this.place_of_Birth=null;

    this.district_Id = null;
    this.district=null;
    this.stateCode=null;
    this.state_Id = null;
    this.state=null;
    this.country_Id=null;
    this.country = null;
    this.city = null;
    this.citizenship = null;
    this.ancestral_Origin = null;
    this.line_1=null;
    this.line_2 =null;

    this.education = null;
    this.institution = null;
    this.employed_In = null;
    this.highesteducation = null;
    this.occupation = null;
    this.from_Income =null;

    this.brotherMarried=null;

  }
}
export default UpdateDetails;